import { useTranslations } from 'next-intl';
import { SITE } from '@/app/constants';

export const useSceneOptions = () => {
  const t = useTranslations();

  const options = [
    {
      value: 'common',
      label: t('agentProject.scene.common.title'),
      desc: t('agentProject.scene.common.tip'),
      icon: (
        <img
          src={
            SITE === 'china'
              ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/scene_common-7ede93de.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/scene_common-7ede93de.webp'
          }
          alt="common"
          className="h-[48px] w-[67px] object-cover"
        />
      ),
    },
    {
      value: 'e_commerce',
      label: t('agentProject.scene.e_commerce.title'),
      desc: t('agentProject.scene.e_commerce.tip'),
      icon: (
        <img
          src={
            SITE === 'china'
              ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/scene_ads-c89ef0e8.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/scene_ads-c89ef0e8.webp'
          }
          alt="e_commerce"
          className="h-[48px] w-[67px] object-cover"
        />
      ),
    },
    {
      value: 'remake',
      label: t('agentProject.scene.remake.title'),
      desc: t('agentProject.scene.remake.tip'),
      icon: (
        <img
          src={
            SITE === 'china'
              ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/scene_remake-975c9e94.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/scene_remake-975c9e94.webp'
          }
          alt="remake"
          className="h-[48px] w-[67px] object-cover"
        />
      ),
    },
  ];

  const getSceneName = (sceneId: string) => {
    return options.find((option) => option.value === sceneId)?.label || '';
  };

  return {
    options,
    getSceneName,
  };
};
